<template>
  <div v-if="establishment != null">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home' }">{{$t('nav.home')}} </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Establishments' }"
            >{{$t('nav.establishments')}}</router-link
          >
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ establishment.esta_internal_name }}
        </li>
      </ol>
    </nav>
    <b-container>
      <b-card-group deck>
        <b-card
          border-variant="secondary"
          header-border-variant="secondary"
        >
          <template #header>
            <h4 class="mb-0">{{$t('label.information')}}
            <b-badge v-if="establishment.esta_is_enable" variant="success"
              >{{$t('label.active')}}</b-badge
            >
            <b-badge v-else variant="danger">{{$t('label.inactive')}} </b-badge>
            <b-badge v-if="establishment.esta_is_internal" variant="primary"
              >{{$t('label.internal')}} </b-badge
            >
          </h4>
          </template>
          <b-card-text class="text-left">
            <b-row class="mb-2">
              <b-col md="4" class="border-bottom bg-light"><i>{{$t('label.name')}} </i></b-col>
              <b-col v-if="establishment.esta_nice_name" md="8">{{
                establishment.esta_nice_name
              }}</b-col>
              <b-col v-else md="8"><i>{{$t('label.empty')}} </i></b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="4" class="border-bottom bg-light"><i>{{$t('label.customer_ref')}}</i> </b-col>
              <b-col md="8">{{ establishment.esta_internal_name }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="4" class="border-bottom bg-light"><i>{{$t('label.login')}} </i></b-col>
              <b-col md="8">{{ establishment.esta_name }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="4" class="border-bottom bg-light"><i>{{$t('label.address')}} </i></b-col>
              <b-col v-if="establishment.esta_address" md="8">{{
                establishment.esta_address
              }}</b-col>
              <b-col v-else md="8"><i>{{$t('label.empty')}}</i></b-col>
            </b-row>
            <b-row>
              <b-col md="4" offset-md="4"
                >{{ establishment.esta_postalcode }}
                {{ establishment.esta_city }}</b-col
              >
            </b-row>
            <b-row>
              <b-col md="4" offset-md="4">{{
                establishment.esta_country
              }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="4" class="border-bottom bg-light"><i>{{$t('label.tablets_count')}} </i></b-col>
              <b-col md="8">{{ establishment.device_count }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="4" class="border-bottom bg-light"><i>{{$t('label.tag_lemon')}} </i></b-col>
              <b-col md="8">{{ establishment.lemon_project_tag }}</b-col>
            </b-row>
            <b-row>
              <b-col md="4" class="border-bottom bg-light"><i>{{$t('label.tags')}} </i></b-col>
              <b-col v-if="establishment.tags" md="8">
                <b-row>
                  <b-col
                    v-for="tag in establishment.tags"
                    :key="'estatag-' + establishment.esta_id + tag.tag_id"
                    class="text-left"
                  >
                    <b-badge :style="{ 'background-color': tag.tag_color }">
                      {{ tag.tag_name }}
                      <b-badge
                        variant="light"
                        style="cursor: pointer"
                        @click="removeTag(tag)"
                      >
                        x
                      </b-badge>
                    </b-badge>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4" class="border-bottom bg-light"><i>{{$t('label.connectors')}} </i></b-col>
              <b-col v-if="establishment.connectors" md="8">
                <span v-for="cnx in establishment.connectors" :key="'cnx-' + cnx.cnt_id">
                  <b-badge :variant="cnx.cnt_enable ? 'success' : 'danger'" :title="cnx.cnt_enable ? 'actif' :' inactif'">
                    {{ cnx.cnt_name }}
                  </b-badge>
                  &nbsp;
                </span>
              </b-col>
              <b-col v-else md="8">
                {{$t('label.empty')}}
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card
          border-variant="secondary"
          :header="$t('label.contact')"
          header-border-variant="secondary"
          align="center"
          class="mb-2"
        >
          <b-card-text class="text-left">
            <b-row class="mb-2">
              <b-col md="4" class="border-bottom bg-light"><i>{{$t('label.phone')}}</i></b-col>
              <b-col v-if="establishment.esta_phone" md="8">{{
                establishment.esta_phone
              }}</b-col>
              <b-col v-else md="8"><i>{{$t('label.empty')}}</i></b-col>
            </b-row>
            <b-row>
              <b-col md="4" class="border-bottom bg-light"><i>{{$t('label.email')}}</i></b-col>
              <b-col v-if="establishment.esta_email" md="8">{{
                establishment.esta_email
              }}</b-col>
              <b-col v-else md="8"><i>{{$t('label.empty')}}</i></b-col>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card
          border-variant="secondary"
          header-border-variant="secondary"
          :header="$t('label.action')"
          align="center"
          class="mb-2"
        >
                <b-row>&nbsp;</b-row>
        <b-row>
          <b-button block v-b-modal.modal-setting-import variant="success"
            ><font-awesome-icon :icon="['fas', 'file-import']" />
            {{$t('btn.import_param')}} </b-button
          >
          <b-modal
            id="modal-setting-import"
            :title="$t('label.import_file_param')"
            scrollable
            hide-footer
          >
            <form-import-list
              :id="establishment.cont_id"
              :button-disabled="isDisabledButtonImportParams"
              @sendForm="receiveFormXlsx"
            />
          </b-modal>
        </b-row>
        <b-row>&nbsp;</b-row>
        <b-row>
         <b-button block v-b-modal.modal-establishment variant="primary">
          <font-awesome-icon :icon="['fas', 'edit']" />
          {{
            $t("btn.update")
          }}</b-button>
           <b-modal
            id="modal-establishment"
            size="xl"
            :title="$t('label.edit_esta')"
            scrollable
          >
            <form-set-establishment
              ref="formSetEstablishment"
              :esta-info="originalEstablishment"
              @sendForm="validateInfoEsta"
            />
            <template #modal-footer="{ cancel }">
              <b-button size="sm" variant="danger" @click="cancel()">
                {{ $t("btn.cancel") }}
              </b-button>
              <b-button size="sm" variant="success" @click="validateInfoEsta">
                {{ $t("btn.save") }}
              </b-button>
            </template>
          </b-modal>
        </b-row>
        <b-row>&nbsp;</b-row>
        <b-row >
         <b-button block variant="warning" @click="exportStatsEsta()">
            <template v-if="IsDownloadStat">
              <b-spinner small type="grow"></b-spinner>
              {{ $t("btn.loading") }}
            </template>
            <template v-else>
              <font-awesome-icon :icon="['fas', 'download']" />
              &nbsp;{{ $t("btn.download_stat_esta") }}
            </template>
          </b-button>
        </b-row>
        <b-row>&nbsp;</b-row>
        <b-row>
          <b-button block variant="warning" v-b-modal.modal-export-stat-v2>
            <font-awesome-icon :icon="['fas', 'download']" />
            {{$t('btn.download_stat_esta')}} v2
          </b-button>
          <b-modal
            id="modal-export-stat-v2"
            :title="$t('label.export_stats_v2')"
            scrollable
            hide-footer
            no-close-on-esc
            no-close-on-backdrop
          >
          <export-stat-establishment :establishment="establishment" />
          </b-modal>
        </b-row>
        <b-row>&nbsp;</b-row>
         <b-row>
          <b-button block variant="primary" v-b-modal.modal_active_features :enabled="false">
            <font-awesome-icon :icon="['fas', ]" />
            Personnalisation des fonctionnalités
          </b-button>
          <modal-enable-extra-features :establishment="establishment" />
          </b-row>
        </b-card>
      </b-card-group>
    </b-container>
    <b-container class="full-container">
      <b-card-group deck>
        <b-card
          border-variant="secondary"
          :header="$t('label.list_modules')"
          header-border-variant="secondary"
          align="center"
        >
          <b-button v-b-toggle="'list-modules'" class="m-1" variant="info"
            >
            <span class="when-open"><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span>
            <span class="when-closed"><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span>
            {{$t('label.list_modules_home')}} </b-button
          >
          <b-button
            v-b-toggle="'list-modules-activities'"
            class="m-1"
            variant="info"
            >
            <span class="when-open"><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span>
            <span class="when-closed"><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span>
            {{$t('label.list_modules_activities')}}</b-button
          >
          <b-button
            v-b-toggle="'list-modules-invisible'"
            class="m-1"
            variant="info"
            > 
            <span class="when-open"><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span>
            <span class="when-closed"><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span>
            {{$t('label.list_modules_fonctional')}} </b-button
          >
        </b-card>
      </b-card-group>
    </b-container>
    <b-collapse id="list-modules" accordion="accordion-modules">
      <b-container class="full-container">
        <b-card-group deck>
          <b-card
            border-variant="secondary"
            :header="$t('label.list_modules_home')"
            header-border-variant="secondary"
            align="center"
          >
            <b-card-text
              ><list-modules
                :establishment="establishment"
                :theme="establishment.theme"
                :devices="devices"
                type="root"
            /></b-card-text>
          </b-card>
        </b-card-group>
      </b-container>
    </b-collapse>
    <b-collapse id="list-modules-activities" accordion="accordion-modules">
      <b-container class="full-container">
        <b-card-group deck>
          <b-card
            border-variant="secondary"
            :header="$t('label.list_modules_activities')"
            header-border-variant="secondary"
            align="center"
          >
            <b-card-text
              ><list-modules
                :establishment="establishment"
                :theme="establishment.theme"
                :devices="devices"
                type="activities"
            /></b-card-text>
          </b-card>
        </b-card-group>
      </b-container>
    </b-collapse>
    <b-collapse id="list-modules-invisible" accordion="accordion-modules">
      <b-container class="full-container">
        <b-card-group deck>
          <b-card
            border-variant="secondary"
            :header="$t('label.list_modules_fonctional')"
            header-border-variant="secondary"
            align="center"
          >
            <b-card-text
              ><list-modules
                :establishment="establishment"
                :theme="establishment.theme"
                :devices="devices"
                type="invisible"
            /></b-card-text>
          </b-card>
        </b-card-group>
      </b-container>
    </b-collapse>
    <b-row>
      <b-col>
        <b-container class="full-container">
          <b-card-group deck>
            <b-card
              border-variant="secondary"
              :header="$t('label.list_access')"
              header-border-variant="secondary"
              align="center"
            >
              <b-card-text><list-access :id="idParams" /></b-card-text>
            </b-card>
          </b-card-group>
        </b-container>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-container class="full-container">
          <b-card-group deck>
            <b-card
              border-variant="secondary"
              :header="$t('label.list_tablets')"
              header-border-variant="secondary"
              align="center"
            >
              <b-card-text
                ><list-devices :devices="devices" :full="true"
              /></b-card-text>
            </b-card>
          </b-card-group>
        </b-container>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-container class="full-container">
          <b-card-group deck>
            <b-card
              border-variant="secondary"
              :header="$t('label.list_staff')"
              header-border-variant="secondary"
              align="center"
            >
              <b-card-text
                ><list-staff :id="idParams" :devices="devices"
              /></b-card-text>
            </b-card>
          </b-card-group>
        </b-container>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-container class="full-container">
          <b-card-group deck>
            <b-card
              border-variant="secondary"
              :header="$t('label.list_resident')"
              header-border-variant="secondary"
              align="center"
            >
              <b-card-text
                ><list-participants :id="idParams" :devices="devices"
              /></b-card-text>
            </b-card>
          </b-card-group>
        </b-container>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-container class="full-container">
          <b-card-group deck>
            <b-card
              border-variant="secondary"
              :header="$t('label.list_domains')"
              header-border-variant="secondary"
              align="center"
            >
              <b-card-text>
                <list-domains :establishment="establishment"/>
              </b-card-text>
            </b-card>
          </b-card-group>
        </b-container>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-container class="full-container">
          <b-card-group deck>
            <b-card
              border-variant="secondary"
              :header="$t('label.list_services')"
              header-border-variant="secondary"
              align="center"
            >
              <b-card-text><list-services :id="idParams" /></b-card-text>
            </b-card>
          </b-card-group>
        </b-container>
      </b-col>
      <b-col>
        <b-container class="full-container">
          <b-card-group deck>
            <b-card
              border-variant="secondary"
              :header="$t('label.list_external_activities')"
              header-border-variant="secondary"
              align="center"
            >
              <b-card-text
                ><list-custom-activities :id="idParams" :connectors="establishment.connectors"
              /></b-card-text>
            </b-card>
          </b-card-group>
        </b-container>
      </b-col>
    </b-row>
    <b-container
      v-if="
        establishment.parent?.esta_id !== null ||
        (establishment.childs != null && establishment.childs.length > 0)
      "
      class="full-container"
    >
      <b-card-group deck>
        <b-card
          border-variant="secondary"
          :header="$t('label.groupe')"
          header-border-variant="secondary"
          align="center"
        >
          <div class="tree">
            <ul v-if="establishment?.parent?.esta_id == null">
              <li>
                <a href="#" class="esta-current">{{
                  establishment.esta_name
                }}</a>
                <ul
                  v-if="
                    establishment.childs != null &&
                    establishment.childs.length > 0
                  "
                >
                  <li
                    v-for="child in establishment.childs"
                    :key="child.esta_id"
                  >
                    <router-link
                      :to="{
                        name: 'EstablishmentDetails',
                        params: { id: child.esta_id }
                      }"
                      replace
                      >{{ child.esta_name }}</router-link
                    >
                  </li>
                </ul>
              </li>
            </ul>
            <ul v-else>
              <li>
                <router-link
                  :to="{
                    name: 'EstablishmentDetails',
                    params: { id: establishment.parent.esta_id },
                  }"
                  replace
                  >{{ establishment.parent.esta_name }}</router-link
                >
                <ul>
                  <li>
                    <a href="#" class="esta-current">{{
                      establishment.esta_name
                    }}</a>
                    <ul
                      v-if="
                        establishment.childs != null &&
                        establishment.childs.length > 0
                      "
                    >
                      <li
                        v-for="child in establishment.childs"
                        :key="child.esta_id"
                      >
                        <router-link
                          :to="{
                            name: 'EstablishmentDetails',
                            params: { id: child.esta_id },
                          }"
                          replace
                          >{{ child.esta_name }}</router-link
                        >
                      </li>
                    </ul>
                  </li>
                  <li
                    v-for="sister in establishment.sisters"
                    :key="sister.esta_id"
                  >
                    <router-link
                      :to="{
                        name: 'EstablishmentDetails',
                        params: { id: sister.esta_id },
                      }"
                      replace
                      >{{ sister.esta_name }}</router-link
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </b-card>
      </b-card-group>
    </b-container>
    <b-container class="full-container">
      <b-card-group deck>
        <b-card
          border-variant="secondary"
          :header="$t('label.anonymisation')"
          header-border-variant="secondary"
          align="center"
        >
          <list-anonymisations :id="idParams" />
        </b-card>
      </b-card-group>
    </b-container>
  </div>
</template>

<script>
import FormEstablishment from "../components/forms/FormEstablishment.vue";
import ListStaff from "../components/lists/ListStaff.vue";
import ListParticipants from "../components/lists/ListParticipants.vue";
import ListModules from "../components/lists/ListModules.vue";
import ListServices from "../components/lists/ListServices.vue";
import ListCustomActivities from "../components/lists/ListCustomActivities.vue";
import ListAccess from "../components/lists/ListAccess.vue";
import FormImportList from "../components/forms/FormImportList.vue";
import ListDevices from "../components/lists/ListDevices.vue";
import ListDomains from "../components/lists/ListDomains.vue";
import ListAnonymisations from "../components/lists/ListAnonymisations.vue";
import {
  setEstablishment,
  getEstablishmentById,
  getDevicesForEstablishment,
} from "../services/establishment";
import { expStatEsta } from "../services/export";
import FormSetEstablishment from "../components/forms/FormSetEstablishment.vue";
import ExportStatEstablishment from "../components/exports/ExportStatEstablishment.vue";
import ModalEnableExtraFeatures from "../components/ModalEnableExtraFeatures.vue";

export default {
  watch: {
    '$route'() {
      if (this.$route?.params?.id) {
        this.idParams = parseInt(this.$route.params.id, 10);
      }
      this.updateStore();
    }
  },
  name: "EstablishmentDetails",
  components: {
    ListDevices,
    FormEstablishment,
    ListStaff,
    ListParticipants,
    ListModules,
    ListDomains,
    ListServices,
    ListCustomActivities,
    FormImportList,
    ListAccess,
    ListAnonymisations,
    FormSetEstablishment,
    ExportStatEstablishment,
    ModalEnableExtraFeatures,
  },
  data() {
    return {
      IsDownloadStat: false,
      originalEstablishment: null,
      isDisabledButtonImportParams: false,
      idParams: -1,
      establishment: null,
      devices: null,
    };
  },
  created() {
    if (this.$route?.params?.id) {
      this.idParams = parseInt(this.$route.params.id, 10);
    }
  },
  async mounted() {
    this.updateStore();
  },
  methods: {
    async updateEsta() {
      this.establishment = await getEstablishmentById(this.idParams);
      this.devices = await getDevicesForEstablishment(this.idParams);
      this.mapEstablishment();
    },
    async updateStore() {
      this.$bvModal.hide("modal-setting-import");
      this.updateEsta();
    },
    async exportStatsEsta() {
      this.IsDownloadStat = true;
      await expStatEsta(this.idParams, `stats_${this.establishment.esta_nice_name}`).then(
        () => (this.IsDownloadStat = false)
      );
    },
    mapEstablishment() {
      this.originalEstablishment = this.establishment;
    },
    async validateInfoEsta() {
      if (this.originalEstablishment.tags) {
        const tagDifference = this.originalEstablishment.tags.filter(
          (object1) =>
            !this.$refs.formSetEstablishment.form.tags.some(
              (object2) => object1.tag_id === object2.tag_id
            )
        );
        tagDifference.forEach((element) => this.removeTag(element));
      }
      if (!this.$refs.formSetEstablishment.form.lemon_project_tag)
        this.$refs.formSetEstablishment.form.lemon_project_tag = 1;
      await setEstablishment(this.$refs.formSetEstablishment.form)
        .then(() => {
          this.showToast('success', this.$t("msg.text.success_upd_esta"), this.$t('msg.title.etablissement'), 2000 )
          this.$root.$emit("bv::hide::modal", "modal-establishment");
        })
        .catch((error) => {
          console.error(error);
          this.showToast('danger', this.$t("msg.text.error_upd_esta"), this.$t('msg.title.etablissement'), 3000 )
        });
      this.updateStore();
    },
    receiveFormXlsx(formList) {
      // this.$root.$emit('bv::hide::modal', 'modal-import-participants-list');
      this.$store
        .dispatch("establishments/importEstablishmentSetting", [
          this.idParams,
          formList,
        ])
        .then(() => this.updateStore())
        .catch((err) => console.log(err));
    },
    removeTag(tag) {
      this.$store
        .dispatch("establishments/removeTag", {
          esta_id: parseInt(this.idParams, 10),
          tag_id: tag.tag_id,
        })
        .then(() => this.updateEsta())
        .catch((error) => this.showToast("danger", error, this.$t('msg.title.tag')));
    },
  },
};
</script>

<style scoped>

.container {
  padding: 10px;
}
.col {
  text-align: justify;
}
.btn {
  margin: 5px;
}
.right-badge {
  text-align: right;
  margin-bottom: 1rem;
}
.tree ul {
  padding-top: 20px;
  position: relative;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  width: fit-content;
  margin: auto;
}

.tree li {
  float: left;
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 20px 5px 0 5px;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

/*We will use ::before and ::after to draw the connectors*/

.tree li::before,
.tree li::after {
  content: "";
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 1px solid #ccc;
  width: 50%;
  height: 20px;
}
.tree li::after {
  right: auto;
  left: 50%;
  border-left: 1px solid #ccc;
}

/*We need to remove left-right connectors from elements without
  any siblings*/
.tree li:only-child::after,
.tree li:only-child::before {
  display: none;
}

/*Remove space from the top of single children*/
.tree li:only-child {
  padding-top: 0;
}

/*Remove left connector from first child and
  right connector from last child*/
.tree li:first-child::before,
.tree li:last-child::after {
  border: 0 none;
}
/*Adding back the vertical connector to the last nodes*/
.tree li:last-child::before {
  border-right: 1px solid #ccc;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}
.tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}

/*Time to add downward connectors from parents*/
.tree ul ul::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 1px solid #ccc;
  width: 0;
  height: 20px;
}

.tree li a {
  min-width: 100px;
  border: 1px solid #ccc;
  padding: 5px 10px;
  text-decoration: none;
  color: #000;
  font-size: 13px;
  display: inline-block;

  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

/*Time for some hover effects*/
/*We will apply the hover effect the the lineage of the element also*/
.tree li a:hover,
.tree li a:hover + ul li a {
  background: #c8e4f8;
  color: #000;
  border: 1px solid #94a0b4;
}
/*Connector styles on hover*/
.tree li a:hover + ul li::after,
.tree li a:hover + ul li::before,
.tree li a:hover + ul::before,
.tree li a:hover + ul ul::before {
  border-color: #94a0b4;
}

.esta-current {
  background: #17a2bf;
  color: white;
}
.card-text {
  color: black;
  font-weight: 400;
  font-size: 1rem;
  line-height: initial;
}
.container .full-container {
  max-width: 100%;
  margin-top: 1%;
}
</style>
